import { useCallback } from "react";
import {
  setIsRefinance,
  setIsGovie,
  setIsVA,
  setIsHELOC,
  setIsIRRRL,
  useLookup,
  parseCompensationValue
} from "./utils.js";
const useTextboxFieldUpdateLogic = () => {
  return useCallback(
    (renderedField, schemaForm) => {
      switch (renderedField.name) {
        case "loanInformation.ltv":
          return (e) => {
            console.log("now here");
            console.log(e);
            const isHeloc = schemaForm.getValues("formValidations.isHeloc");
            const getLoanValue = 0;
            const getLoanMaxValue = 0;
            if (isHeloc) {
              schemaForm.setValue(
                "loanInformation.loanAmountMaxLine",
                getLoanMaxValue
              );
            } else {
              schemaForm.setValue(
                "loanInformation.firstMortgageAmount",
                getLoanValue
              );
            }
            renderedField.onChange(e);
          };
        default:
          return renderedField.onChange;
      }
    },
    []
  );
};
const useCheckboxFieldUpdateLogic = () => {
  return useCallback(
    (renderedField, schemaForm) => {
      switch (renderedField.name) {
        default:
          return () => renderedField.onChange(!renderedField.value);
      }
    },
    []
  );
};
const useSingleComboboxFieldUpdateLogic = () => {
  const parseValue = (value) => {
    if (!Array.isArray(value)) {
      if (value?.value && !isNaN(Number(value.value))) {
        return parseInt(value.value, 10);
      }
      return value?.value ?? null;
    }
    return value.map(
      (option) => !isNaN(Number(option.value)) ? parseInt(option.value, 10) : option.value
    );
  };
  return useCallback(
    (renderedField, schemaForm) => (value) => {
      switch (renderedField.name) {
        case "loanInformation.loanPurpose":
          setIsRefinance(schemaForm, value);
          return renderedField.onChange(parseValue(value));
        case "loanInformation.targetLabel":
          schemaForm.setValue(
            "loanInformation.target",
            !Array.isArray(value) && value?.value === "Low" ? 100 : null
          );
          return renderedField.onChange(parseValue(value));
        case "compensation.model":
          schemaForm.setValue(
            "compensation.model",
            parseCompensationValue(
              !Array.isArray(value) ? value?.value : null
            )
          );
          return renderedField.onChange(parseValue(value));
        default:
          return renderedField.onChange(parseValue(value));
      }
    },
    []
  );
};
const useMultiComboboxFieldUpdateLogic = () => {
  const lookupsLoanTerms = useLookup("loanTerms", null);
  const parseValues = (value) => {
    if (Array.isArray(value)) {
      return value.map(
        (option) => !isNaN(Number(option.value)) ? parseInt(option.value, 10) : option.value
      );
    }
    return value;
  };
  return useCallback(
    (renderedField, schemaForm) => (value) => {
      switch (renderedField.name) {
        case "standardProducts":
          setIsGovie(schemaForm, value);
          setIsVA(schemaForm, value);
          return renderedField.onChange(parseValues(value));
        case "specialProducts":
          setIsIRRRL(schemaForm, value);
          return renderedField.onChange(parseValues(value));
        case "productType":
          setIsHELOC(schemaForm, value, lookupsLoanTerms);
          return renderedField.onChange(parseValues(value));
        default:
          return renderedField.onChange(parseValues(value));
      }
    },
    []
  );
};
export {
  useCheckboxFieldUpdateLogic,
  useMultiComboboxFieldUpdateLogic,
  useSingleComboboxFieldUpdateLogic,
  useTextboxFieldUpdateLogic
};
